module.exports = __webpack_public_path__ + "static/media/EPI.b85b36b9.png";